import { useRef, useEffect, useState } from "react";
import { SCREENS } from "../../utils/CommonUtils/constants";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { IconButton, Button } from "@mui/material";
import CardsGroupComponent from "../../components/CardsGroupComponent/CardsGroupComponent";
import useTranslationSetup from "../../utils/useTranslationSetup";
import ArrowBackIosIcon from "../../assets/arrow_back_ios.svg";
import ArrowForwardIosIcon from "../../assets/arrow_forward_ios.svg";
import "./VopaInstructionScreen.css";

function VopaInstructionScreen({
  instructionContent,
  setActiveScreen,
  flowType,
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { t } = useTranslationSetup();
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  return (
    <div className="vopa-instructions-screen-box">
      <div className="vopa-instructions-screen-heading">
        {flowType === "assessment" ? t("assessment_time") : t("cohort_time")}
      </div>
      <div className="vopa-instructions-screen-desc">
        {flowType === "assessment"
          ? t("ensure_the_following_when_conducting_an_assessment")
          : t("ensure_the_following_when_viewing_a_cohort")}
      </div>
      <div className="cards-with-navigation">
        {currentIndex !== 0 && (
          <IconButton
            className="chevron-button prev theme-color"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <img
              src={ArrowBackIosIcon}
              alt="arrow-back-icon"
              className="chevron-icon"
            />
          </IconButton>
        )}
        <div className="cards-component-vopa-instruction">
          <CardsGroupComponent>
            <Swiper
              modules={[Navigation, Autoplay]}
              pagination={{ clickable: true }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => setCurrentIndex(swiper.activeIndex)}
            >
              {instructionContent.map((item, index) => (
                <SwiperSlide key={index}>
                  <div>{item.gif}</div>
                  <div className="vopa-instruction-heading">{item.heading}</div>
                  <div className="vopa-instruction-desc">
                    {item.content}
                    {item.heading === t("finish_the_paragraph") && (
                      <span className="vopa-instruction-desc-span">
                        {" "}
                        {t("read_it_aloud")}
                      </span>
                    )}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </CardsGroupComponent>
        </div>

        {currentIndex !== instructionContent.length - 1 && (
          <IconButton
            className="chevron-button next theme-color"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <img
              src={ArrowForwardIosIcon}
              alt="arrow-forward-icon"
              className="chevron-icon"
            />
          </IconButton>
        )}
      </div>
      <div className="swiper-paginations">
        {instructionContent.map((_, index) => (
          <span
            key={index}
            className={`swiper-pagination-bullet ${index === currentIndex ? "swiper-pagination-bullet-active" : ""}`}
            onClick={() => swiperRef.current.slideTo(index)}
          />
        ))}
      </div>
      <div className="sticky">
        <div className="seen-instructions-before-text">
          {flowType === "assessment"
            ? t("have_seen_instructions_before")
            : t("have_seen_cohort_instructions")}
        </div>
        <div className="vopa-instruction-button">
          <Button
            variant={
              currentIndex < instructionContent.length - 1
                ? "outlined"
                : "contained"
            }
            className="vopa-instruction-continue-skip-button"
            style={{
              color:
                currentIndex < instructionContent.length - 1
                  ? "#A2C357"
                  : "#FFF",
              background:
                currentIndex < instructionContent.length - 1 ? "" : "#A2C357",
            }}
            disableElevation
            onClick={() =>
              setActiveScreen(
                flowType === "assessment"
                  ? SCREENS.RENDER_ASSESSMENT_LOADING_SCREEN
                  : SCREENS.RENDER_COHORT_LOADING_SCREEN
              )
            }
          >
            {currentIndex < instructionContent.length - 1
              ? t("skip")
              : t("continue")}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default VopaInstructionScreen;
